<!-- layouts/PublicLayout.vue -->
<template>
  <div class="relative">
    <Loading />

    <NavBar :nav-links="navLinks"/>

    <slot /> <!-- This will render the actual page content -->

    <FooterBig/>
    <Background2/>
    <BackToTop/>
  </div>
</template>

<script setup lang="ts">
import bgImage from '@/assets/images/anymic/stadium-top.jpg';
import BackToTop from "@/components/BackToTop.vue";
import Background2 from "@/components/Background2.vue";
import FooterBig from "@/components/FooterBig.vue";
import NavBar from "@/components/NavBar.vue";
import Loading from "@/components/layout/Loading.vue";
// TODO use another footer here

const navLinks = [
  { id: 'home', label: 'Home', route: { url: '/home' } },
  { id: 'events', label: 'Events', route: { url: '/events' } },
  { id: 'announcers', label: 'Announcers', route: { url: '/announcers' } },
  { id: 'providers', label: 'Broadcasters', route: { url: '/providers' } },
  { id: 'partners', label: 'Partners', route: { url: '/partners' } },
  { id: 'company', label: 'Company', route: { url: '/company' } }
];

</script>

<style scoped>

</style>
